import type { Membership } from '@/lib/tenant';

export function pushTenantIdsForMemberships(
  memberships: readonly Pick<Membership, 'tenant_id' | 'user_id'>[],
  userId: string | null | undefined
): string[] {
  if (!userId) {
    return [];
  }

  return [
    ...new Set(
      memberships
        .filter((membership) => membership.user_id === userId)
        .map((membership) => membership.tenant_id)
    ),
  ];
}
